import { NimmstaLayout } from './NimmstaLayout';
const LAYOUT = `<?xml version="1.0" encoding="utf-8"?>
<NimmstaLayout name="Three Cell Layout with Headers">
    <device width="1.54" height="1.54" pxx="200" pxy="200">
        <screen default="true" name="default">
            <staticElements>
                <statusbar />
                <cell x="3" y="25" horizontalAlignment="left" fontSize="11pt" name="header1"></cell>
                <cell x="3" horizontalAlignment="left" fontSize="auto" name="text1"></cell>
                <horizontalLine y="85"></horizontalLine>
                <cell x="3" horizontalAlignment="left" fontSize="11pt" name="header2"></cell>
                <cell x="3" horizontalAlignment="left" fontSize="auto" name="text2"></cell>
                <horizontalLine y="150"></horizontalLine>
                <cell x="3" horizontalAlignment="left" fontSize="11pt" name="header3"></cell>
                <cell x="3" horizontalAlignment="left" fontSize="auto" wrapMode="wrap" maxLines="0" name="text3"></cell>
            </staticElements>
        </screen>
    </device>
</NimmstaLayout>
`;
export class ThreeCellHeaderLayout extends NimmstaLayout {
    constructor(header1, text1, header2, text2, header3, text3) {
        super(LAYOUT, {
            header1, text1, header2, text2, header3, text3,
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGhyZWVDZWxsSGVhZGVyTGF5b3V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9tb2RlbHMvbGF5b3V0cy9UaHJlZUNlbGxIZWFkZXJMYXlvdXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRWhELE1BQU0sTUFBTSxHQUFHOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQmQsQ0FBQztBQUtGLE1BQU0sT0FBTyxxQkFBc0IsU0FBUSxhQUFhO0lBQ3RELFlBQVksT0FBZSxFQUFFLEtBQWEsRUFDeEMsT0FBZSxFQUFFLEtBQWEsRUFDOUIsT0FBZSxFQUFFLEtBQWE7UUFDOUIsS0FBSyxDQUFDLE1BQU0sRUFBRTtZQUNaLE9BQU8sRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsS0FBSztTQUMvQyxDQUFDLENBQUM7SUFDTCxDQUFDO0NBQ0YifQ==